import { Icon } from '@components/index';

interface SwitchAccountProps {
  isProfileList: boolean;
  onClickSwitchAccount: () => void;
}

const SwitchAccount = ({
  isProfileList,
  onClickSwitchAccount
}: SwitchAccountProps) => (
  <div
    className={`flex cursor-pointer items-center rounded-md py-2 text-sm font-normal hover:bg-cofeeGreyBlue75 ${
      isProfileList
        ? 'ml-2 mr-1 gap-3 py-2.5 pl-3 pr-2 hover:bg-cofeeGreyBlue75'
        : 'mx-1 gap-3 px-4 py-2.5 hover:bg-cofeeGreyBlue75'
    }`}
    onClick={onClickSwitchAccount}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        onClickSwitchAccount();
      }
    }}
    tabIndex={0}
    role="button"
  >
    <Icon
      name="switch-account"
      size="none"
      className={`size-4.5 ${
        isProfileList ? 'text-cofeeNeutral8' : 'text-cofeeNeutral10'
      }`}
    />
    Switch accounts
  </div>
);

export default SwitchAccount;
